import auth from './auth';
import layout from './layout';
import dictionary from './dictionary';

export default {
    auth,
    dictionary,
    layout,
}
